import React from "react";
import { cn } from "../lib/utils";

type Tone = "default" | "brand" | "brandLight";

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  tone?: Tone;
}

// Simple radial beam halo
export default function Beam({ className, tone = "default", ...props }: Props) {
  const gradient =
    tone === "brand"
      ? "radial-gradient(50% 50% at 50% 50%, rgba(99,102,241,0.30) 10%, rgba(99,102,241,0.0) 60%)"
      : tone === "brandLight"
      ? "radial-gradient(50% 50% at 50% 50%, rgba(199,210,254,0.30) 10%, rgba(199,210,254,0.0) 60%)"
      : "radial-gradient(50% 50% at 50% 50%, rgba(255,255,255,0.25) 10%, rgba(255,255,255,0.0) 60%)";

  return (
    <div data-slot="beam" className={cn("relative", className)} {...props}>
      <div
        className={cn(
          "pointer-events-none absolute inset-0 -z-10 left-1/2 top-1/2 h-[220%] w-[220%] -translate-x-1/2 -translate-y-1/2 rounded-full blur-2xl opacity-40",
        )}
        style={{ background: gradient }}
      />
    </div>
  );
}
